const stagedTeams = state => state.stagedTeams;
const stagedMembers = state => state.stagedMembers;
const stagedOrganizations = state => state.stagedOrganizations;
const isGoal = state => state.formData.isGoal.value;
const goal = state => state.formData.steps.value;
const mapId = state => state.formData.mapId.value;
const challengeType = state => state.options.challengeType;
const chartType = state => state.options.chartType;
const activeStep = state => state.activeStep;
const formData = state => state.formData;
const options = state => state.options;
const memberMode = state => state.memberMode;
const teamMode = state => state.teamMode;
const packageMode = state => state.packageMode;
const selectedPackage = state => state.selectedPackage;
const pointsGoalPerDay = state => state.pointsGoalPerDay;

export default {
  stagedTeams,
  stagedMembers,
  stagedOrganizations,
  isGoal,
  goal,
  mapId,
  activeStep,
  formData,
  challengeType,
  chartType,
  options,
  memberMode,
  teamMode,
  packageMode,
  selectedPackage,
  pointsGoalPerDay
};
